import script from "./errorComponent.vue?vue&type=script&lang=js"
export * from "./errorComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__